const PRETTY_UNICODE = {
  '\u00BD': 1 / 2,
  '\u2153': 1 / 3,
  '\u2154': 2 / 3,
  '\u00BC': 1 / 4,
  '\u00BE': 3 / 4,
  '\u215B': 1 / 8
}

const PRETTY_TEXT = {
  '1/2': 1 / 2,
  '1/3': 1 / 3,
  '2/3': 2 / 3,
  '1/4': 1 / 4,
  '3/4': 3 / 4,
  '1/8': 1 / 8
}

export default {
  ingredient(item){
    if(!item) return ''
    const ingredient = item.ingredient || item.food
    if(!ingredient || !ingredient.name) return ''

    return `${this.ingredientAmount(item)} ${this.ingredientName(item)}`
  },

  ingredientAmount(item, multiplier = 1, style = 'unicode'){
    if(!item) return ''
    const ingredient = item.ingredient || item.food
    if(!ingredient || !ingredient.name) return ''

    let amount = item.amount || ''
    if(amount !== '' && !isNaN(amount)) amount *= multiplier

    return this.amount(amount, style)
  },

  ingredientUnit(item, multiplier = 1){
    if(!item) return ''
    if(!item.unit) return ''
    const ingredient = item.ingredient || item.food
    if(!ingredient || !ingredient.name) return ''


    let amount = item.amount || ''
    if(amount !== '' && !isNaN(amount)) amount *= multiplier

    return this.unit(item.unit, amount)
  },

  ingredientName(item, multiplier = 1){
    if(!item) return ''
    const ingredient = item.ingredient || item.food
    if(!ingredient || !ingredient.name) return ''

    let amount = item.amount || ''
    if(amount !== '' && !isNaN(amount)) amount *= multiplier

    const name = this.food(ingredient, amount, item)
    const prefix = this.pluralize(item.prefix, amount)
    const suffix = this.pluralize(item.suffix, amount)

    let output = ''

    if(prefix) output += ` ${prefix}`

    output += ` ${name}`

    if(suffix) output += ` ${suffix}`

    return output
  },


  /*
    Style:
      unicode
      text
      numer
  */
  amount(amount, style = 'unicode'){
    let value = parseFloat(amount)

    if(isNaN(value)) return ''
    if(style === 'number') return value
    const rest = value % 1
    let full = value - rest

    if(full >= 10) return full
    if(full === 0) full = ''

    if(rest > 1 / 16) {
      const PRETTY = style === 'unicode' ? PRETTY_UNICODE : PRETTY_TEXT
      let min = 1
      let _name
      for(let name in PRETTY){
        if(PRETTY.hasOwnProperty(name)){
          if(Math.abs(PRETTY[name] - rest) <= min){
            min = Math.abs(PRETTY[name] - rest)
            _name = name
          }
        }
      }

      if(!full) value = _name
      else value = [full, _name].join(style === 'unicode' ? '' : ' ')
    }else{
      value -= rest
    }

    return value
  },

  unit(unit, amount){
    if(!unit.symbol){
      const tmp = ' ' + this.pluralize(this.translation(unit.name) || '', amount)
      if(tmp === ' ') return ''
      return tmp
    }
    return this.pluralize(this.translation(unit.symbol), amount)
  },


  food(food, amount, custom = {}){
    let name = this.translation(food.name)

    if(custom.custom_name && custom.name) name = custom.name

    return this.pluralize(name, amount)
  },


  PLURAL_DELIMITER: ' | ',
  pluralize(name, amount){
    name = name || ''
    const parts = name.split(this.PLURAL_DELIMITER)

    if(parts.length > 1){
      let p = amount > 1 ? 1 : 0
      if(amount === 0) p = 1
      return parts[p]
    }

    return name.replace(/( \||\| )/, '')
  },


  decimals(value, decimals){
    const tt = Math.pow(10, decimals)
    return Math.round(value * tt) / tt
  },


  translation(value){
    if(!value) return ''
    return value.replace(/^<.+?>\s/, '')
  },



  regexp(str, flags) {
    str = str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&')
    return new RegExp(str, flags)
  },


  minutes(minutes){
    if(minutes < 60) return `${minutes}min`
    if(minutes % 60 === 0){
      return `${(minutes / 60)}h`
    }

    const hours = Math.floor(minutes / 60)
    minutes = minutes - hours * 60
    return `${hours}h ${minutes}min`
  }
}



// WEBPACK FOOTER //
// ./shared/lib/format.js